import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import {Grid} from "@mui/material";

// Components
import CustomButton from "components/CustomButton";
import Popup from "components/WMS/Mobile/Popup";

// Assets
import Trolley from "assets/img/wms/trolley.svg";

// Api
import {wmsItemRemoveFromTrolley} from "api/wms/wmsItems/wmsItems";

RemoveFromTrolleyPopup.propTypes = {
    wmsItem: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    onRemove: PropTypes.func
};

function RemoveFromTrolleyPopup({wmsItem, open = false, handleClose = () => {}, onRemove = () => {}}) {
    async function removeWmsItem() {
        if (!wmsItem) {
            return;
        }
        
        const res = await wmsItemRemoveFromTrolley(wmsItem);

        if (res) {
            onRemove();
        }
    }

    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={
                <FormattedMessage id='wms.myPickingMissions.popup.removeFromTrolley.title' />
            }
            subtitle={
                <FormattedMessage id='wms.myPickingMissions.popup.removeFromTrolley.description' />
            }
            icon={<img src={Trolley} alt={"Trolley"} />}
            isMobile={true}
        >
            <Grid container>
                <Grid container item direction={"column"}>
                    <CustomButton
                        fullWidth
                        style={{marginBottom: "16px"}}
                        onClick={removeWmsItem}
                    >
                        <FormattedMessage id='wms.myPickingMissions.popup.removeFromTrolley.action' />
                    </CustomButton>
                    <CustomButton
                        onClick={handleClose}
                        color={"default"}
                        fullWidth
                    >
                        <FormattedMessage id='wms.myPickingMissions.popup.removeFromTrolley.cancel' />
                    </CustomButton>
                </Grid>
            </Grid>
        </Popup>
    );
}

export default RemoveFromTrolleyPopup;
